import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './RatingQrCode.module.scss';

const DEFAULT_QR_LABEL = 'QR код для прохождения опроса';

type RatingQrCodeProps = {
  url: string;
  labelText?: string | null;
  compact?: boolean;
};

export const RatingQrCode: FC<RatingQrCodeProps> = ({ url, labelText, compact }) => {
  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${encodeURIComponent(url)}`;

  return (
    <div className={classNames(classes.wrap, compact && classes.compact)}>
      <img src={qrSrc} alt="QR-код опроса" className={classes.qr} />
      <p className={classes.label}>{labelText?.trim() || DEFAULT_QR_LABEL}</p>
    </div>
  );
};
